
import React from 'react';
import Layout from '../components/Layout';
import { Helmet } from 'react-helmet';
import { Info, Shield } from 'lucide-react';

const About = () => {
  return (
    <Layout showBackButton>
      <Helmet>
        <title>About Us - Calculator</title>
        <meta name="description" content="Learn more about our calculator website and important disclaimers about using our services." />
      </Helmet>

      <div className="container mx-auto px-6 md:px-10 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <Info className="h-8 w-8 text-primary" />
            <h1 className="text-3xl font-bold">About Us</h1>
          </div>

          <div className="prose prose-lg dark:prose-invert max-w-none">
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8">
              Welcome to Calculator, your trusted resource for various calculations and estimations.
              Our mission is to provide user-friendly, accessible tools to help you make informed decisions.
            </p>

            <div className="bg-gray-50 dark:bg-gray-900 rounded-lg p-6 mb-8">
              <div className="flex items-center gap-3 mb-4">
                <Shield className="h-6 w-6 text-primary" />
                <h2 className="text-xl font-semibold">Important Disclaimer</h2>
              </div>
              <div className="space-y-4">
                <p className="text-gray-600 dark:text-gray-300">
                  The calculators and information on this website are provided for general informational purposes only. 
                  No results or information should be considered as professional advice, nor should they be relied upon 
                  as the sole basis for making decisions.
                </p>
                <p className="text-gray-600 dark:text-gray-300">
                  All calculations are estimates and may not be accurate for your specific situation. Use of this 
                  website is at your own risk. The owner of this website disclaims all liability for any damages 
                  or losses arising from the use of the calculators or the information provided.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default About;
